import gql from "graphql-tag";

export const GET_ALL_ANNOUNCEMENT = gql`
    query Query {
        getAllAnnouncement
    }
`;

export const GET_ALL_NOTIFICATION = gql`
    query GetAllNotification($profileId: String!) {
        getAllNotification(PROFILE_ID: $profileId) {
            count
            data {
                NOTIFICATION_ID
                TITLE
                N_DESCRIPTION
                PROFILE_ID
                IS_DELETED
                CREATED_BY
                UPDATED_BY
                CREATED_AT
                UPDATED_AT
            }
        }
    }
`;
